/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ENUM_ORDER_DELIVERY {
  cdek = "cdek",
  ozon = "ozon",
  self = "self",
}

export enum ENUM_ORDER_ORDER_STATUS {
  CANCELLED_4 = "CANCELLED_4",
  CREATED_1 = "CREATED_1",
  DONE_3 = "DONE_3",
  ERROR_5 = "ERROR_5",
  FUNDED_2 = "FUNDED_2",
}

export enum ENUM_PAYMENT_PAYMENTSTATUS {
  CANCELLED_3 = "CANCELLED_3",
  CREATED_1 = "CREATED_1",
  ERROR_5 = "ERROR_5",
  PAID_2 = "PAID_2",
  REFUND_4 = "REFUND_4",
}

export enum ENUM_POSITION_CATEGORY {
  candles = "candles",
  dinner = "dinner",
  handler = "handler",
  interior = "interior",
}

export interface AromaFiltersInput {
  documentId?: IDFilterInput | null;
  name?: StringFilterInput | null;
  description?: StringFilterInput | null;
  group?: StringFilterInput | null;
  notes?: StringFilterInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (AromaFiltersInput | null)[] | null;
  or?: (AromaFiltersInput | null)[] | null;
  not?: AromaFiltersInput | null;
}

export interface BooleanFilterInput {
  and?: (boolean | null)[] | null;
  or?: (boolean | null)[] | null;
  not?: BooleanFilterInput | null;
  eq?: boolean | null;
  eqi?: boolean | null;
  ne?: boolean | null;
  nei?: boolean | null;
  startsWith?: boolean | null;
  endsWith?: boolean | null;
  contains?: boolean | null;
  notContains?: boolean | null;
  containsi?: boolean | null;
  notContainsi?: boolean | null;
  gt?: boolean | null;
  gte?: boolean | null;
  lt?: boolean | null;
  lte?: boolean | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (boolean | null)[] | null;
  notIn?: (boolean | null)[] | null;
  between?: (boolean | null)[] | null;
}

export interface CalcPosition {
  documentId: string;
  quantity?: number | null;
  aromaDocumentId?: string | null;
}

export interface CollectionFiltersInput {
  documentId?: IDFilterInput | null;
  name?: StringFilterInput | null;
  enabled?: BooleanFilterInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (CollectionFiltersInput | null)[] | null;
  or?: (CollectionFiltersInput | null)[] | null;
  not?: CollectionFiltersInput | null;
}

export interface DateTimeFilterInput {
  and?: (any | null)[] | null;
  or?: (any | null)[] | null;
  not?: DateTimeFilterInput | null;
  eq?: any | null;
  eqi?: any | null;
  ne?: any | null;
  nei?: any | null;
  startsWith?: any | null;
  endsWith?: any | null;
  contains?: any | null;
  notContains?: any | null;
  containsi?: any | null;
  notContainsi?: any | null;
  gt?: any | null;
  gte?: any | null;
  lt?: any | null;
  lte?: any | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (any | null)[] | null;
  notIn?: (any | null)[] | null;
  between?: (any | null)[] | null;
}

export interface FloatFilterInput {
  and?: (number | null)[] | null;
  or?: (number | null)[] | null;
  not?: FloatFilterInput | null;
  eq?: number | null;
  eqi?: number | null;
  ne?: number | null;
  nei?: number | null;
  startsWith?: number | null;
  endsWith?: number | null;
  contains?: number | null;
  notContains?: number | null;
  containsi?: number | null;
  notContainsi?: number | null;
  gt?: number | null;
  gte?: number | null;
  lt?: number | null;
  lte?: number | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (number | null)[] | null;
  notIn?: (number | null)[] | null;
  between?: (number | null)[] | null;
}

export interface IDFilterInput {
  and?: (string | null)[] | null;
  or?: (string | null)[] | null;
  not?: IDFilterInput | null;
  eq?: string | null;
  eqi?: string | null;
  ne?: string | null;
  nei?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
  contains?: string | null;
  notContains?: string | null;
  containsi?: string | null;
  notContainsi?: string | null;
  gt?: string | null;
  gte?: string | null;
  lt?: string | null;
  lte?: string | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (string | null)[] | null;
  notIn?: (string | null)[] | null;
  between?: (string | null)[] | null;
}

export interface OrderInput {
  order_status?: ENUM_ORDER_ORDER_STATUS | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone?: string | null;
  delivery?: ENUM_ORDER_DELIVERY | null;
  delivery_data?: any | null;
  promo?: string | null;
  cost_sum?: number | null;
  cost_discount?: number | null;
  cost_delivery?: number | null;
  cost_total?: number | null;
  promo_accepted?: boolean | null;
  positions?: any | null;
  publishedAt?: any | null;
}

export interface PaginationArg {
  page?: number | null;
  pageSize?: number | null;
  start?: number | null;
  limit?: number | null;
}

export interface PaymentInput {
  paymentUrl?: string | null;
  paymentStatus?: ENUM_PAYMENT_PAYMENTSTATUS | null;
  createObject?: any | null;
  updateObject?: any | null;
  order?: string | null;
  orderId?: string | null;
  publishedAt?: any | null;
}

export interface PositionFiltersInput {
  documentId?: IDFilterInput | null;
  article?: StringFilterInput | null;
  category?: StringFilterInput | null;
  name?: StringFilterInput | null;
  collections?: CollectionFiltersInput | null;
  description?: StringFilterInput | null;
  structure?: StringFilterInput | null;
  aroma?: StringFilterInput | null;
  price?: FloatFilterInput | null;
  old_price?: FloatFilterInput | null;
  volume?: StringFilterInput | null;
  hit?: BooleanFilterInput | null;
  new?: BooleanFilterInput | null;
  pre_order?: BooleanFilterInput | null;
  aromas?: AromaFiltersInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (PositionFiltersInput | null)[] | null;
  or?: (PositionFiltersInput | null)[] | null;
  not?: PositionFiltersInput | null;
}

export interface StringFilterInput {
  and?: (string | null)[] | null;
  or?: (string | null)[] | null;
  not?: StringFilterInput | null;
  eq?: string | null;
  eqi?: string | null;
  ne?: string | null;
  nei?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
  contains?: string | null;
  notContains?: string | null;
  containsi?: string | null;
  notContainsi?: string | null;
  gt?: string | null;
  gte?: string | null;
  lt?: string | null;
  lte?: string | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (string | null)[] | null;
  notIn?: (string | null)[] | null;
  between?: (string | null)[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
